
import React, { useMemo } from 'react';
// Added ExclamationTriangleIcon to imports
import { SearchIcon, SpinnerIcon, XMarkIcon, HomeModernIcon, CheckCircleIcon, MapPinIcon, ExclamationTriangleIcon } from '../../Icons';
import { formatCurrency } from '../../../utils/formatters';

const BANK_LOGOS: Record<string, string> = {
    "Davivienda": "https://lh3.googleusercontent.com/4sKYlqqRD_onoXutM5Bn3gPb0l-28gns-nZ_ZjomdEnA9VWo02fYHxzr7cWTNBGzPyEnO0odzlO1bIPw3c_IS1EnTAN6K6hGeLtm_32aOM4HAwtwDas",
    "BBVA": "https://imagenes.elpais.com/resizer/v2/AQ5FYPCNSY3V4R6ZF5DYXEP6YY.jpg?auth=48297151e29896714d810077b72fafb3657c63db6730aaa46eed9adef551fc26&width=1200",
    "Banco de Bogotá": "https://d31dn7nfpuwjnm.cloudfront.net/images/valoraciones/0023/7354/Banco_de_Bogot%C3%A1.jpg?1464013869",
    "Bancolombia": "https://d31dn7nfpuwjnm.cloudfront.net/images/valoraciones/0045/7454/como-hacer-prestamo-bancolombia.png?1632424421",
    "Banco de Occidente": "https://yt3.googleusercontent.com/ytc/AIdro_kBdSa4CR36Ut-GwHDEoF8NLTGbYhmQpy7lFiY2Lk2e8Ec=s900-c-k-c0x00ffffff-no-rj",
    "Banco Caja Social": "https://d31dn7nfpuwjnm.cloudfront.net/images/valoraciones/0057/5270/banco-caja-social.png?1695901863",
    "Banco AV Villas": "https://d31dn7nfpuwjnm.cloudfront.net/images/valoraciones/0058/8321/avances-av-villas.png?1702577488",
    "Itau": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Banco_Ita%C3%BA_logo.svg/1184px-Banco_Ita%C3%BA_logo.svg.png",
    "Credifamilia": "https://credifamilia.com/sites/default/files/Logo%20Credifamilia.png"
};

export const PropertySearchStep: React.FC<any> = ({ state, actions }) => {
  const visibleBanks = useMemo(() => {
    if (state.isAbroad) return ["Davivienda", "BBVA", "Banco de Bogotá", "Bancolombia"];
    if (state.isCiencuadrasProperty) return ["Davivienda", "BBVA", "Banco de Bogotá", "Banco de Occidente", "Banco Caja Social", "Banco AV Villas", "Itau", "Credifamilia"];
    return ["BBVA", "Banco de Bogotá", "Banco de Occidente", "Banco Caja Social", "Banco AV Villas", "Itau", "Credifamilia"];
  }, [state.isAbroad, state.isCiencuadrasProperty]);
  
  return (
    <div className="p-8 space-y-10 animate-fade-in-down">
      {/* SECCIÓN ORIGEN */}
      <section>
        <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-4">¿Cuál es el origen del inmueble?</h3>
        <div className="grid grid-cols-2 gap-4">
            {[ {v:true, l:'Inmueble Ciencuadras'}, {v:false, l:'Inmueble Externo'} ].map(opt => (
                <button 
                    key={String(opt.v)}
                    onClick={() => { actions.setIsCiencuadrasProperty(opt.v); actions.setSelectedBank(null); }} 
                    disabled={state.isLocked}
                    className={`flex items-center justify-between px-6 py-4 rounded-2xl border-2 transition-all group ${state.isCiencuadrasProperty === opt.v ? 'bg-sky-50 border-sky-500 shadow-lg shadow-sky-100' : 'bg-white border-gray-100 opacity-60 hover:opacity-100 hover:border-gray-200'}`}
                >
                    <span className={`text-sm font-black uppercase tracking-tight ${state.isCiencuadrasProperty === opt.v ? 'text-sky-900' : 'text-gray-500'}`}>{opt.l}</span>
                    {state.isCiencuadrasProperty === opt.v && <CheckCircleIcon className="w-5 h-5 text-sky-600" />}
                </button>
            ))}
        </div>
      </section>

      {/* BÚSQUEDA CÓDIGO */}
      {state.isCiencuadrasProperty && (
        <section className="animate-fade-in">
          <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-4">Localiza el inmueble en el inventario</h3>
          {!state.selectedProperty ? (
            <div className="flex bg-gray-50 p-2 rounded-2xl border-2 border-gray-100 focus-within:border-sky-500 transition-all shadow-inner">
              <input 
                type="text" 
                value={state.searchCode} 
                onChange={(e) => actions.setSearchCode(e.target.value)} 
                placeholder="Ingresa el código del inmueble..." 
                className="flex-grow border-none bg-transparent text-sm font-bold text-gray-800 focus:ring-0 px-4" 
                onKeyDown={(e) => e.key === 'Enter' && actions.performSearch(state.searchCode)}
                disabled={state.isLocked} 
              />
              <button 
                onClick={() => actions.performSearch(state.searchCode)} 
                disabled={state.isSearching || !state.searchCode || state.isLocked} 
                className="px-8 py-3 bg-[#E4002B] hover:bg-red-700 text-white rounded-xl font-black uppercase text-[10px] tracking-widest shadow-lg transition-all active:scale-95 disabled:opacity-30"
              >
                {state.isSearching ? <SpinnerIcon className="w-4 h-4 animate-spin"/> : 'Buscar'}
              </button>
            </div>
          ) : (
            <div className="flex flex-col sm:flex-row items-center gap-6 p-6 bg-white border-2 border-sky-100 rounded-3xl relative shadow-xl shadow-sky-50 animate-fade-in group">
              <div className="w-full sm:w-32 h-32 bg-gray-100 rounded-2xl overflow-hidden shadow-inner border border-gray-100">
                {state.selectedProperty.images?.[0] ? <img src={state.selectedProperty.images[0]} className="w-full h-full object-cover" alt="Selected property thumbnail" /> : <HomeModernIcon className="w-full h-full p-8 text-gray-300"/>}
              </div>
              <div className="flex-grow min-w-0 text-center sm:text-left space-y-2">
                <span className="inline-block text-[9px] font-black bg-sky-600 text-white px-3 py-1 rounded-full uppercase tracking-widest">{state.selectedProperty.tipoinmueble}</span>
                <h3 className="font-black text-2xl text-[#00234F] tracking-tighter leading-none">{formatCurrency(state.selectedProperty.precio_venta)}</h3>
                <div className="flex items-center justify-center sm:justify-start text-xs text-gray-400 font-bold uppercase gap-1">
                    <MapPinIcon className="w-3.5 h-3.5"/>
                    <span className="truncate">{state.selectedProperty.direccion}</span>
                </div>
              </div>
              {!state.isLocked && (
                <button 
                    onClick={() => { actions.setSelectedProperty(null); actions.setSearchCode(''); }} 
                    className="absolute top-4 right-4 p-2 bg-gray-50 text-gray-400 hover:text-red-500 rounded-full transition-all border border-gray-100"
                ><XMarkIcon className="w-5 h-5"/></button>
              )}
            </div>
          )}
          {state.searchError && <p className="text-[10px] text-red-500 mt-3 font-black uppercase tracking-tight flex items-center gap-1"><ExclamationTriangleIcon className="w-3 h-3"/> {state.searchError}</p>}
        </section>
      )}

      {/* UBICACIÓN CLIENTE */}
      <section className="pt-2">
        <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-4">¿Dónde reside el cliente?</h3>
        <div className="flex gap-4">
          {[ {v:false, l:'Nacional'}, {v:true, l:'Exterior'} ].map(opt => (
              <button 
                key={String(opt.v)}
                onClick={() => { actions.setIsAbroad(opt.v); actions.setSelectedBank(null); }} 
                className={`flex-1 px-6 py-4 rounded-2xl border-2 transition-all font-black uppercase text-xs tracking-widest ${state.isAbroad === opt.v ? 'bg-[#00234F] border-[#00234F] text-white shadow-xl shadow-blue-100 scale-105' : 'bg-white border-gray-100 text-gray-400 hover:border-gray-200'}`}
              >{opt.l}</button>
          ))}
        </div>
      </section>

      {/* BANCOS */}
      <section className="pt-2">
        <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-4">Selecciona el Banco para el referido</h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {visibleBanks.map(bank => (
            <button 
              key={bank} 
              onClick={() => actions.setSelectedBank(bank)} 
              className={`flex flex-col items-center p-5 rounded-2xl border-2 transition-all min-h-[110px] justify-center relative shadow-sm group ${state.selectedBank === bank ? 'border-sky-500 bg-sky-50 ring-4 ring-sky-100' : 'border-gray-100 bg-white hover:border-sky-200 hover:shadow-md'}`}
            >
              {BANK_LOGOS[bank] ? (
                <img src={BANK_LOGOS[bank]} className="h-10 max-w-full object-contain mb-3 grayscale group-hover:grayscale-0 transition-all opacity-80 group-hover:opacity-100" alt={bank} />
              ) : (
                <span className="text-xs font-black text-center text-gray-700 uppercase tracking-tighter mb-2">{bank}</span>
              )}
              <span className="text-[9px] font-black text-gray-400 group-hover:text-sky-700 uppercase tracking-widest mt-auto">{bank}</span>
              {state.selectedBank === bank && (
                <div className="absolute -top-2 -right-2 bg-white rounded-full p-0.5 shadow-lg border border-sky-100">
                    <CheckCircleIcon className="w-6 h-6 text-sky-600" />
                </div>
              )}
            </button>
          ))}
        </div>
      </section>
    </div>
  );
};
